export default __webpack_public_path__ + "assets/icon-groups-black.d537ef5c.webp";